import script from "./ProductAttributeComponent.vue?vue&type=script&lang=ts&setup=true"
export * from "./ProductAttributeComponent.vue?vue&type=script&lang=ts&setup=true"

import "./ProductAttributeComponent.vue?vue&type=style&index=0&id=00dfddab&lang=scss&scoped=true"

import exportComponent from "/home/issa/hcpet/hcpet-kasse/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-00dfddab"]])

export default __exports__